import { generatePath } from "@routes/generatePath.ts";
import type { ID, IPatientType } from "@constants";

const writeSummaryNoteRoute = "/summary-notes-management/write/:appointment_id";
const viewSummaryNoteRoute = "/summary-notes-list/view/:id";
const viewPatientSummaryNoteRoute =
  "/summary-notes-list/:patient_id/:patient_type";
const writeAddendumRoute = "/summary-notes-management/addendum/write/:id";

export const path = {
  list: {
    route: "/summary-notes-list",
    link: () => path.list.route,
  },
  management: {
    route: "/summary-notes-management",
    link: () => path.management.route,
  },
  writeSummary: {
    route: writeSummaryNoteRoute,
    link: (appointmentId: ID) =>
      generatePath(writeSummaryNoteRoute, { appointment_id: appointmentId }),
  },
  viewSummary: {
    route: viewSummaryNoteRoute,
    link: (summaryNoteId: ID) =>
      generatePath(viewSummaryNoteRoute, { id: summaryNoteId }),
  },
  writeAddendum: {
    route: writeAddendumRoute,
    link: (summaryNoteId: ID) =>
      generatePath(writeAddendumRoute, { id: summaryNoteId }),
  },
  patientSummaryList: {
    route: viewPatientSummaryNoteRoute,
    link: (patientId: ID, patientType: IPatientType) =>
      generatePath(viewPatientSummaryNoteRoute, {
        patient_type: patientType,
        patient_id: patientId,
      }),
  },
};
